// extracted by mini-css-extract-plugin
export default {"formFailBlock":"WithdrawalForm-module__formFailBlock--eUi0r"};